import { render, staticRenderFns } from "./ScoringAlert.vue?vue&type=template&id=660457ce&"
import script from "./ScoringAlert.vue?vue&type=script&lang=js&"
export * from "./ScoringAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports